// (De)serialization between the flat registry.requires.dataset.* labels (as
// stored in a document's metadata.labels) and the structured DatasetReq[] used
// by the editor and binding-contract panel. This is the dataset-only half of
// the binding contract — registry.requires.param.* is retired; declared params
// now come from bino-cli's native metadata.params (see lib/param-spec.ts).

import type { DatasetReq } from "./derive-requires.js";
import { splitCsv } from "./format.js";

/** extractDatasetRequires parses the flat dataset labels into a DatasetReq[]. */
export function extractDatasetRequires(labels: Record<string, string>): DatasetReq[] {
  return splitCsv(labels["registry.requires.datasets"]).map((name) => ({
    name,
    columns: labels[`registry.requires.dataset.${name}.columns`] ?? "",
    description: labels[`registry.requires.dataset.${name}.description`] ?? "",
  }));
}

/** toDatasetLabels serializes a DatasetReq[] back into the flat label map. */
export function toDatasetLabels(datasets: DatasetReq[]): Record<string, string> {
  const out: Record<string, string> = {};
  if (!datasets.length) return out;
  out["registry.requires.datasets"] = datasets.map((d) => d.name).join(",");
  for (const d of datasets) {
    if (d.columns) out[`registry.requires.dataset.${d.name}.columns`] = d.columns;
    if (d.description) out[`registry.requires.dataset.${d.name}.description`] = d.description;
  }
  return out;
}
